import api from '@/api'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import moment from 'moment'
import pdfMake from 'pdfmake/build/pdfmake.js'
import { mapGetters } from 'vuex'
import { shipping } from './shippingbase64.js'
import numeral from 'numeral'
import cloneDeep from 'lodash/cloneDeep'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}

export default {
  props: {
    orders: {
      default: undefined
    },
    circle: {
      default: undefined
    },
    type: {
      default: false
    }
  },
  data() {
    return {
      profile: '',
      loading: false,
      loadingsave: false,
      showEditAddress: false,
      input: {
        pageaddress: ''
      },

      regularsize: 14,
      headersize: 18
    }
  },
  components: {
    ShippingAddress
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      addresses: 'getShippingAddress'
    })
  },
  methods: {
    saveContent() {
      let vm = this
      this.showEditAddress = false
      this.getShopProfile()
      // vm.loadingsave = true
      // api.editShopProfile({ ...this.getPageProfile, pageaddress: this.input.pageaddress }, function(
      //   error,
      //   response
      // ) {
      //   vm.loadingsave = false

      //   if (error) {
      //     console.error(error)
      //     return
      //   }
      //   vm.$store.state.pageProfile.pageaddress = vm.input.pageaddress
      //   vm.getShopProfile()
      //   vm.showEditAddress = false
      // })
    },
    cancelEdit() {
      this.showEditAddress = false
      this.input.pageaddress = ''
    },
    skipEdit() {
      this.showEditAddress = false
      this.input.pageaddress = ''
      this.profile = {
        companyname: '',
        phoneno: '',
        pageaddress: ''
      }
      var vm = this
      vm.$emit('onPrinCover', {
        printPdf: function (orders) {
          vm.printPDF(orders)
        }
      })
    },
    clickPrintPdf() {
      if (this.getPageProfile.pageaddress || (this.addresses && this.addresses.length > 0)) {
        this.getShopProfile()
      } else {
        this.showEditAddress = true
      }
    },
    getShopProfile: async function () {
      let vm = this
      vm.loading = true
      if (!vm.selectedBot.pageid || vm.selectedBot.pageid == null) {
        vm.loading = false
        return false
      }

      if (this.addresses && this.addresses.length > 0) {
        var address = this.addresses.find((el) => {
          return el.selected
        })
        this.profile = {
          companyname: address.name,
          phoneno: address.tel,
          pageaddress:
            address.addressno +
            ' , ' +
            address.sub_district +
            ' , ' +
            address.district +
            ' , ' +
            address.province +
            ' , ' +
            address.postcode
        }

        vm.$emit('onPrinCover', {
          printPdf: function (orders) {
            vm.printPDF(orders)
          }
        })
      } else if (this.getPageProfile.pageaddress) {
        await vm.getShopAddress()
        vm.$emit('onPrinCover', {
          printPdf: function (orders) {
            vm.printPDF(orders)
          }
        })
      } else {
        this.showEditAddress = true
      }
      vm.loading = false
    },
    getShopAddress() {
      var vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        let auth = null
        api.getShopProfile(data, function (error, response) {
          if (error) {
            console.error(error)
            reject()
            return
          }
          // console.log(response)
          if (response.shopprofile) {
            vm.profile = response.shopprofile
            try {
              vm.profile.companyname = JSON.parse(response.shopprofile.description).companyname
              vm.profile.phoneno = JSON.parse(response.shopprofile.description).phoneno
            } catch (error) {
              vm.profile.companyname = ''
              vm.profile.phoneno = ''
            }
            resolve()
            // console.log(vm.profile)
            // console.log(response.shopprofile.descriptio)
          }
        })
      })
    },
    async myShippingImg() {
      // var shipping = {
      //   flash_charge: '',
      //   additionalproduct_charge: '',
      //   nim_charge: '',
      //   ninjavan_charge: '',
      //   jtexpress_charge: '',
      //   lalamove_charge: '',
      //   cjlogistics_charge: '',
      //   nikos_charge: '',
      //   scgexpress_charge: '',
      //   skootar_charge: '',
      //   alphaexpress_charge: '',
      //   deliveree_charge: '',
      //   grab_charge: '',
      //   lineman_charge: '',
      //   tnt_charge: '',
      //   cod_charge: '',
      //   normal_charge: '',
      //   ems_charge: '',
      //   kerry_charge: '',
      //   bestexpress_charge: '',
      //   interexpress_charge: '',
      //   dhl_charge: '',
      //   other_charge: '',
      //   other2_charge: '',
      //   other3_charge: '',
      //   other4_charge: '',
      //   other5_charge: ''
      // }
      // return new Promise(async (resolve, reject) => {
      //   for (var item in shipping) {
      //     shipping[item] = await this.getBase64Image(
      //       'https://' +
      //         window.location.host +
      //         '/static/img/assets/payment/mini/' +
      //         (item.includes('other') ? 'other_charge' : item) +
      //         '_logo.jpg'
      //     )
      //   }
      //   return resolve(shipping)
      // })

      return Promise.resolve(shipping)
    },
    getBase64Image(url) {
      return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        xhr.onload = function () {
          var reader = new FileReader()
          reader.onloadend = function () {
            resolve(reader.result)
          }
          reader.readAsDataURL(xhr.response)
        }
        xhr.onerror = function (e) {
          reject(e)
        }
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.send()
      })
    },
    async formatTemplate(orders) {
      var shippinglist = this.$store.state.shippinglist
      var vm = this

      var shippingtypeimg = await this.myShippingImg()
      var receiptText = vm.$t('Receipt')
      if (
        [
          '148831989096546',
          '1229692217050821',
          '135565533158593',
          '488563718210335',
          '799590883441878'
        ].includes(vm.selectedBot.pageid)
      ) {
        receiptText = vm.$t('ใบกำกับภาษี/ใบเสร็จรับเงิน')
      }

      var data = orders.map((el, i) => {
        var productdetail
        if (vm.selectedBot.theme == 'runkan') {
          receiptText = `${vm.$t('Receipt')} (${
            el.runkanstatus == 'SUCCESS' ? 'วิ่งสำเร็จ' : 'วิ่งไม่สำเร็จ'
          })`
        }
        var payment = vm.$t('Credit card')
        if (el.payment == 'banktransfer' || el.payment == 'transfer') {
          payment = vm.$t('Bank Transfer')
        } else if (el.payment == 'qrcode') {
          payment = 'Qr Code'
        } else if (el.payment == 'fbpay') {
          payment = vm.$t('Mobile Banking')
        } else if (el.payment == 'cod') {
          payment = vm.$t('cod_charge')
        }
        var formatproductdetail = []
        try {
          productdetail = JSON.parse(el.productdetail)
          if (this.type == 'nvbbpreorder') {
            let product_columns_1 = [],
              product_columns_2 = []

            let product_length = Math.ceil(productdetail.length / 2)
            // if (product_length > 1) {
            product_columns_2 = cloneDeep(productdetail)
            product_columns_1 = product_columns_2.splice(0, product_length)
            // } else {
            //   product_columns_1 = cloneDeep(productdetail)
            // }
            for (let index = 0; index < product_length; index++) {
              const val = product_columns_1[index]
              const val2 = product_columns_2[index] || null
              formatproductdetail.push([
                {
                  text: index + 1 + '. ' + val.name + ` x ${val.quantity} (${val.option})`,
                  style: { fontSize: vm.regularsize },
                  bold: true
                },
                {
                  text: val2
                    ? product_length +
                      (index + 1) +
                      '. ' +
                      val2.name +
                      ` x ${val2.quantity} (${val2.option})`
                    : '',
                  style: { fontSize: vm.regularsize },
                  bold: true
                }
              ])
            }
          } else {
            formatproductdetail = productdetail.map((val, i) => {
              if (
                [
                  '148831989096546',
                  '1229692217050821',
                  '135565533158593',
                  '488563718210335',
                  '799590883441878'
                ].includes(vm.selectedBot.pageid)
              ) {
                return [
                  {
                    text: i + 1 + '. ' + val.name + ` x ${val.quantity} (${val.option})`,
                    style: { fontSize: vm.regularsize },
                    bold: true
                  },
                  {
                    text: numeral(val.price).format('0,0.00'),
                    style: { fontSize: vm.regularsize },
                    alignment: 'right'
                  }
                ]
              } else {
                return [
                  {
                    text: i + 1 + '. ' + val.name + ` x ${val.quantity} (${val.option})`,
                    style: { fontSize: vm.regularsize },
                    bold: true
                  }
                ]
              }
            })
          }
        } catch (error) {
          console.log(error)
          productdetail = []
          formatproductdetail = [{ text: el.productdetail }]
        }
        if (
          [
            '148831989096546',
            '1229692217050821',
            '135565533158593',
            '488563718210335',
            '799590883441878'
          ].includes(vm.selectedBot.pageid)
        ) {
          formatproductdetail.push([
            { text: 'ยอดรวม', style: { fontSize: vm.regularsize }, bold: true },
            { text: el.total, style: { fontSize: vm.regularsize }, alignment: 'right' }
          ])
        }
        if (this.type == 'nvbbpreorder') {
          let count = 0
          if (productdetail && productdetail.length > 0) {
            count = productdetail.reduce((prev, curr) => {
              if (curr.quantity) prev += parseInt(curr.quantity)
              return prev
            }, 0)
          }
          formatproductdetail.push([
            {},
            { text: 'ยอดรวม: ' + count, style: { fontSize: vm.regularsize }, bold: true }
          ])
        }

        if (this.type == 'nvbbpreorder') {
          return [
            {
              // width: 225,
              table: {
                widths: ['*', '*'],
                heights: [60],
                body: [
                  [
                    {
                      text: [
                        {
                          text: vm.$t('Sender') + '\n',
                          style: { fontSize: 12 },
                          bold: true
                        },
                        {
                          text: `${vm.profile.companyname ? vm.profile.companyname + ', ' : ''}${
                            vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno + ', ' : ''
                          } ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                          style: { fontSize: 12 },
                          bold: true
                        }
                      ],
                      style: 'container',
                      lineHeight: 1
                    },
                    {
                      text: [
                        {
                          text: vm.$t('Receiver') + '\n',
                          style: { fontSize: 12 },
                          bold: true
                        },
                        {
                          text: vm.noSpaceAndSpecial(el.nameaddress),
                          style: { fontSize: 12 },
                          bold: true
                        }
                      ],
                      style: 'container'
                    }
                  ]
                ]
              }
            },
            {
              table: {
                widths: [50, 162, 93, 55],
                lineHeight: 0.5,
                body: [
                  [
                    {
                      text: vm.$t('Order No:'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    { text: el.id, style: { fontSize: vm.regularsize }, bold: true },
                    {
                      text: vm.selectedBot.theme ? 'Delivery Date: ' : vm.$t('Order Date: '),
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: moment(el.shippingdate).format('DD/MM/YYYY'),
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    }
                  ]
                ]
              },
              layout: {
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineWidth: function (i, node) {
                  return 0
                },
                hLineWidth: function (i, node) {
                  return 0
                }
              }
            },
            {
              table: {
                widths: [100, 162],
                body: [
                  [
                    {
                      text: vm.$t('Shipping option'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: vm.$t(
                        el.shippingtype && el.shippingtype.includes('other')
                          ? shippinglist[el.shippingtype][4]
                          : el.shippingtype
                      ),
                      style: { fontSize: vm.regularsize },
                      margin: [0, 0, 10, 0],
                      bold: true
                    }
                  ]
                ]
              },

              layout: {
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineWidth: function (i, node) {
                  return 0
                },
                hLineWidth: function (i, node) {
                  return 0
                }
              }
            },
            {
              stack: [
                {
                  text: vm.$t('Remark'),
                  style: { fontSize: vm.regularsize },
                  bold: true
                },
                {
                  text: el.remark != null ? el.remark.replaceAll('\n', '').replaceAll('​', '') : '',
                  style: { fontSize: vm.regularsize },
                  bold: true
                }
              ]
            },
            {
              text: vm.$t('Product Detail'),
              margin: [0, 5, 0, 2],
              style: {
                bold: true,
                fontSize: vm.headersize
              }
            },
            {
              table: {
                widths: [185, 185],
                body: formatproductdetail
              },
              // layout: {
              //   hLineColor: function(i, node) {
              //     return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              //   },
              //   vLineColor: function(i, node) {
              //     return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              //   }
              // },
              pageBreak: i + 1 == orders.length || el.payment == 'cod' ? '' : 'after'
            },
            ...(el.payment != 'cod'
              ? []
              : [
                  {
                    pageBreak: i + 1 == orders.length ? '' : 'after',
                    margin: [0, 10, 0, 0],
                    table: {
                      widths: [200 + 175],
                      body: [
                        // [vm.$t('Subtotal') + ':', { text: '฿' + el.total, style: { alignment: 'right' } }],
                        [
                          // { text: , style: { fontSize: vm.regularsize } },
                          {
                            text: vm.$t('Total price') + ': ' + '฿' + el.amount,
                            style: { alignment: 'right', fontSize: vm.regularsize + 2 },
                            bold: true
                          }
                        ]
                      ]
                    },
                    layout: {
                      vLineWidth: function (i, node) {
                        return 0
                      },
                      hLineWidth: function (i, node) {
                        return 0
                      }
                    }
                  }
                ])
          ]
        } else
          return [
            {
              // width: 225,
              table: {
                widths: ['*'],
                heights: [60],
                body: [
                  [
                    {
                      text: [
                        { text: vm.$t('Sender') + '\n', style: 'header' },
                        {
                          text: `${vm.profile.companyname ? vm.profile.companyname + ', ' : ''}${
                            vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno + ', ' : ''
                          } ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                          style: 'paragraph',
                          bold: true
                        }
                      ],
                      style: 'container',
                      lineHeight: 1
                    }
                  ]
                ]
              }
            },
            {
              margin: [0, 6, 0, 0],
              table: {
                widths: ['*'],
                heights: [60],
                body: [
                  [
                    {
                      text: [
                        { text: vm.$t('Receiver') + '\n', style: 'header' },
                        {
                          text: vm.noSpaceAndSpecial(el.nameaddress),
                          style: 'paragraph',
                          bold: true
                        }
                      ],
                      style: 'container'
                    }
                  ]
                ]
              }
            },
            {
              margin: [0, 10, 0, 0],
              columns: [
                {
                  text: receiptText,
                  style: 'receipt'
                }
              ]
            },
            {
              table: {
                widths: [50, 162, 93, 55],
                lineHeight: 0.5,
                body: [
                  [
                    {
                      text: vm.$t('Order No:'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    { text: el.id, style: { fontSize: vm.regularsize }, bold: true },
                    {
                      text: vm.selectedBot.theme ? 'Delivery Date: ' : vm.$t('Order Date: '),
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: moment(el.timestamp).format('DD/MM/YYYY'),
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    }
                  ]
                ]
              },
              layout: {
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineWidth: function (i, node) {
                  return 0
                },
                hLineWidth: function (i, node) {
                  return 0
                }
              }
            },
            {
              table: {
                widths: [200, 175],
                body: [
                  [
                    {
                      text: vm.$t('Shipping option'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      columns: [
                        {
                          text: vm.$t(
                            el.shippingtype && el.shippingtype.includes('other')
                              ? shippinglist[el.shippingtype][4]
                              : el.shippingtype
                          ),
                          width: '*',
                          style: { alignment: 'right', fontSize: vm.regularsize },
                          margin: [0, 0, 10, 0],
                          bold: true
                        },
                        {
                          image: shippingtypeimg[el.shippingtype]
                            ? shippingtypeimg[el.shippingtype]
                            : shippingtypeimg['other_charge'],
                          width: 40,
                          style: { alignment: 'right', fontSize: vm.regularsize - 3 }
                        }
                      ]
                    }
                  ],
                  [
                    {
                      text: vm.$t('Payment Method'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: payment,
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    }
                  ],
                  [
                    {
                      text: vm.$t('Remark'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text:
                        el.remark != null &&
                        [
                          '148831989096546',
                          '1229692217050821',
                          '135565533158593',
                          '488563718210335',
                          '799590883441878'
                        ].includes(vm.selectedBot.pageid)
                          ? el.remark.split(';;')[0]
                          : el.remark,
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    }
                  ]
                ]
              },
              layout: {
                hLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineColor: function (i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineWidth: function (i, node) {
                  return 0
                },
                hLineWidth: function (i, node) {
                  return 0
                }
              }
            },
            {
              text: vm.$t('Product Detail'),
              margin: [0, 5, 0, 2],
              style: {
                bold: true,
                fontSize: vm.headersize
              }
            },
            {
              table: {
                widths: [
                  '148831989096546',
                  '1229692217050821',
                  '135565533158593',
                  '488563718210335',
                  '799590883441878'
                ].includes(vm.selectedBot.pageid)
                  ? [300, 70]
                  : [370],
                body: formatproductdetail
              },
              // layout: {
              //   hLineColor: function(i, node) {
              //     return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              //   },
              //   vLineColor: function(i, node) {
              //     return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              //   }
              // },
              pageBreak: i + 1 == orders.length || el.payment == 'cod' ? '' : 'after'
            },
            ...(el.payment != 'cod'
              ? []
              : [
                  {
                    pageBreak: i + 1 == orders.length ? '' : 'after',
                    margin: [0, 10, 0, 0],
                    table: {
                      widths: [200 + 175],
                      body: [
                        // [vm.$t('Subtotal') + ':', { text: '฿' + el.total, style: { alignment: 'right' } }],
                        [
                          // { text: , style: { fontSize: vm.regularsize } },
                          {
                            text: vm.$t('Total price') + ': ' + '฿' + el.amount,
                            style: { alignment: 'right', fontSize: vm.regularsize + 2 },
                            bold: true
                          }
                        ]
                      ]
                    },
                    layout: {
                      vLineWidth: function (i, node) {
                        return 0
                      },
                      hLineWidth: function (i, node) {
                        return 0
                      }
                    }
                  }
                ])
          ]
      })

      return data
    },
    async printPDF(orders) {
      var data = await this.formatTemplate(orders)
      var dd = {
        content: [data],
        pageSize: 'A5',
        pageMargins: [15, 15, 15, 15],
        styles: {
          header: {
            fontSize: this.headersize,
            // color: '#ff5656',
            bold: true
          },
          paragraph: {
            fontWeight: 200,
            fontSize: this.regularsize
          },
          container: {
            margin: [2, 2, 2, 2]
          },
          receipt: {
            fontSize: this.headersize,
            // color: '#ff5656',
            bold: true
          }
        },
        defaultStyle: {
          font: 'THSarabunNew'
        }
      }
      this.loading = false
      pdfMake.createPdf(dd).open()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/ecommerce/PrintAllCovers.js